import WushuStyleManager from './WushuStyleManager';

export default WushuStyleManager;
